export default "__VITE_ASSET__phiHJP5C__"